export const IconDownloadStatistics = ({ color = "white" }) => {

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="18" viewBox="0 0 15 18" fill="none">
            <g clipPath="url(#clip0_3735_2461)">
                <path d="M14.0102 0.716335C13.5521 0.254049 12.9315 0 12.2776 0H5.73068C5.51411 0 5.30588 0.0832948 5.15178 0.23739L0.23739 5.15178C0.0832948 5.30171 0 5.51411 0 5.72652V9.00416V11.0116V12.2235V15.0347C0 15.826 0.258214 16.584 0.7205 17.1379C1.18279 17.696 1.80333 18.0042 2.4572 18.0042H3.27765H11.4614H12.2818C12.9357 18.0042 13.5562 17.696 14.0185 17.1379C14.4808 16.5798 14.739 15.8218 14.739 15.0347V12.2235V11.0116V6.5428V3.6025V2.4572C14.7307 1.80333 14.4725 1.17446 14.0102 0.716335ZM1.63674 9V6.5428H5.73068C5.94725 6.5428 6.15548 6.45951 6.30958 6.30541C6.46367 6.15132 6.54697 5.94308 6.54697 5.72652V1.63674H12.2776C12.4942 1.63674 12.7025 1.72004 12.8565 1.87413C13.0106 2.02823 13.0939 2.23646 13.0939 2.45303V3.6025V6.5428V9.87876H12.7483H1.98242H1.63674V9ZM4.60204 16.2008L4.1814 15.3596C4.01064 15.0347 3.8982 14.7932 3.76909 14.5266H3.75659C3.6608 14.7973 3.54419 15.0389 3.39843 15.3596L3.01111 16.2008H1.8075L3.15271 13.8478L1.85747 11.5488H3.06525L3.47339 12.3984C3.61083 12.6816 3.71495 12.9065 3.82739 13.1731H3.83989C3.94817 12.8774 4.0398 12.6691 4.15641 12.3984L4.54789 11.5488H5.74734L4.43545 13.8186L5.81397 16.2008H4.60204ZM9.28737 16.205H6.38038V11.553H7.43822V15.3221H9.28737V16.205ZM11.0491 16.2716C10.516 16.2716 9.99121 16.1342 9.73299 15.9884L9.94539 15.118C10.2286 15.2638 10.6617 15.4095 11.1115 15.4095C11.5946 15.4095 11.8487 15.2096 11.8487 14.9056C11.8487 14.6182 11.6279 14.4516 11.0699 14.2517C10.2952 13.981 9.7913 13.5562 9.7913 12.8774C9.7913 12.0819 10.4535 11.478 11.553 11.478C12.0777 11.478 12.4651 11.5863 12.7399 11.7112L12.5067 12.5609C12.3193 12.4734 11.9903 12.3401 11.5322 12.3401C11.0782 12.3401 10.8575 12.5484 10.8575 12.7899C10.8575 13.0856 11.1199 13.2189 11.7196 13.4438C12.54 13.7478 12.9273 14.1768 12.9273 14.8306C12.9232 15.6094 12.3235 16.2716 11.0491 16.2716Z" fill={color} />
            </g>
            <defs>
                <clipPath id="clip0_3735_2461">
                    <rect width="14.7307" height="18" fill="white" />
                </clipPath>
            </defs>
        </svg>
    )
}

export const IconAddVMP = () => {
    return (
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12.9075 5.8704H8.12957V1.09257C8.12957 -0.36419 5.87029 -0.36419 5.87029 1.09257V5.8704H1.09233C-0.364109 5.8704 -0.364109 8.1296 1.09233 8.1296H5.87029V12.9074C5.87029 14.3642 8.12957 14.3642 8.12957 12.9074V8.1296H12.9075C14.3642 8.1296 14.3642 5.8704 12.9075 5.8704Z" fill="#606060" />
        </svg>
    )
}

export const headCellsPermissions = [
    {
        id: 'id',
        numeric: false,
        disablePadding: false,
        label: '#'
    },
    {
        id: 'roleCode',
        numeric: false,
        disablePadding: false,
        label: 'table.roleCode',
    },
    {
        id: 'roleName',
        numeric: false,
        disablePadding: false,
        label: 'table.roleName',
    },
    {
        id: 'scopeCategory',
        numeric: false,
        disablePadding: false,
        label: 'table.scopeCategory',
    },
    {
        id: 'roleDesc',
        numeric: false,
        disablePadding: false,
        label: 'table.roleDesc',
    },
    {
        id: 'defaultValue',
        numeric: false,
        disablePadding: false,
        label: 'table.defaultValue',
    },
    {
        id: 'mergeStrategy',
        numeric: false,
        disablePadding: false,
        label: 'table.mergeStrategy',
    },
    {
        id: 'status',
        numeric: false,
        disablePadding: false,
        label: 'table.status',
    },
    {
        id: 'actions',
        numeric: false,
        disablePadding: false,
        label: 'table.actions'
    },
];

export const FUNCTION_DATA_TYPE = [
    { value: 0, label: 'Boolean' },
    { value: 1, label: 'String' },
    { value: 2, label: 'Integer' },
    { value: 3, label: 'Float' },
    { value: 4, label: 'UTC_Timestamp' },
]

export const FUNCTION_DATA_DEFAULT = [
    { value: 'TRUE', label: 'TRUE' },
    { value: 'FALSE', label: 'FALSE' }
]

export const FUNCTION_SCOPE_CATEGORY = [
    { value: 'SYSTEM', label: 'SYSTEM' },
    { value: 'NON_SYSTEM', label: 'NON_SYSTEM' }
]

export const FUNCTION_MEGER_STRATEGY = [
    { value: 'OR', label: 'OR' },
    { value: 'MAX', label: 'MAX' },
    { value: 'MIN', label: 'MIN' },
    { value: 'SUM', label: 'SUM' },
    { value: 'UNION', label: 'UNION' }
]

export const ERROR_CODE_FUNCTION_CREATE = {
    "Code has been used": "toast.error.title.functionCodeHasBeenUsed",
    "Don't have permission": "toast.error.title.dontHavePermission"
}

export const ERROR_CODE_FUNCTION_UPDATE = {
    "ER_DUP_ENTRY": "toast.error.title.functionCodeHasBeenUsed",
    "Don't have permission": "toast.error.title.dontHavePermission"
}

export const ERROR_CODE_FUNCTION_DELETE = {
    "Function is used or be required for other function": "manageRole:toast.error.inUseOrRequired",
    "Don't have permission": "toast.error.title.dontHavePermission"
}

export const API_CODE_CREATE_ROLE = {
    "0": "pgRole:toast.success-role",
    "1": "pgRole:toast.name-role-used",
    "2": "manageRole:toast.error.invalidPriority"
}

export const API_CODE_DELTE_ROLE = {
    "Roles is in used": "manageRole:toast.error.roleInUsed"
}